import { inject } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from '../../../node_modules/@types/react-router';
import { CommonActionButton } from '../../SharedComponents/CommonActionButton';
import { FullScreenModalContainer } from '../../SharedComponents/FullScreenModalContainer';
import { InformationIcon } from '../../SharedComponents/InformationIcon';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { TightKnitLogoBrown, WelcomeImage } from '../../images/images';

interface IProps {
    store: ApplicationStore;
}

@inject('store')
export class OnboardingWelcome extends React.Component<RouteComponentProps<any> & IProps> {
    private onClickStart = () => {
        this.props.history.push(Routes.ALBUMS, { showLearningCenter: true });
    }

    public render() {

        // This may be used in the future. Leaving it here for reference
        // const wasInvited = this.props.location.state && this.props.location.state.wasInvited;

        return (
            <FullScreenModalContainer
                justifyContent="center"
                alignItems="center"
                {...this.props}
                innerContainerStyle={{backgroundColor: 'white'}}
                // onPressExit={() => this.props.history.push(Routes.ALBUMS)}
            >
                <p style={styles.header}>Welcome to TightKnit!</p>
                <p style={styles.subHeader}>Your account has been created.</p>
                <img src={WelcomeImage} style={styles.image} />

                <React.Fragment>
                    <p style={styles.caption}>Join family and friends in sharing stories behind treasured photos.</p>

                    <div style={styles.buttonRow}>
                        <CommonActionButton onClick={this.onClickStart} buttonContent={'Watch Quick-Start Video'} containerStyle={{width: 300}} />
                    </div>
                </React.Fragment>

                <div style={styles.logoContainer}>
                    <img src={TightKnitLogoBrown} style={styles.logo} />
                </div>
            </FullScreenModalContainer>
        );
    }
}

const styles: {[key: string]: React.CSSProperties} = {
    spacer: {
        width: 20,
    },
    header: {
        fontSize: 45,
        fontFamily: 'ProximaNovaSemiBold, Arial, sans-serif'
    },
    subHeader: {
        fontSize: 30,
    },
    image: {
        width: '80%',
        objectFit: 'contain',
    },
    caption: {
        fontSize: 30,
        width: '80%',
        textAlign: 'center',
    },
    promptWrap: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    },
    promptMargin: {
        marginTop: 25,
        marginBottom: 15,
    },
    prompt: {
        fontSize: 22,
        fontWeight: 'bold',
        color: 'black',
    },
    promptInfoIcon: {
        position: 'absolute',
        height: '1.6em',
        right: '-2.2em'
    },
    buttonRow: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 50,
    },
    skipButton: {
        width: 250,
        opacity: 0.8,
    },
    invitedActionButtonWrap: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
    },
    invitedActionButtonInfoIcon: {
        position: 'absolute',
        height: '2em',
        right: '-2.5em'
    },
    logoContainer: {
        position: 'absolute',
        top: 30,
        left: 50,
        height: 200,
        width: 200,
    },
    logo: {
        height: '100%',
        width: '100%',
        objectFit: 'contain',
    },
};



// WEBPACK FOOTER //
// ./src/Pages/OnboardingPages/OnboardingWelcome.tsx